import { injectionMoldingAccionesRoles } from '../../acciones-roles/departamentos/injection-molding-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

const accessToAllIMNR = [
  'Chief',
  'Admin',
  'Viewer',
  'InjectionMoldingAdmin',
  'InjectionMoldingChief',
  'InjectionMoldingViewer',
  'InjectionMoldingSupervisor',
];

export const InjectionMoldingRoutes: SideBarButton = {
  data: {
    name: 'Injection Molding',
    appendUrl: './injection-molding',
    roles: [...injectionMoldingAccionesRoles.sideNavActions.root],
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Planeacion',
        url: '/planning',
        roles: [...injectionMoldingAccionesRoles.sharedActions.planning],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Produccion',
        url: '/scheduler',
        roles: [...injectionMoldingAccionesRoles.sharedActions.scheduler],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Moldes',
        url: '/molds',
        roles: [...injectionMoldingAccionesRoles.sharedActions.molds],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Calidad',
        url: '/quality-control',
        roles: [...injectionMoldingAccionesRoles.sharedActions.qualityControl],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Rechazado QC',
        url: '/qc-rejected',
        roles: [...injectionMoldingAccionesRoles.sharedActions.qcRejected],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: [...injectionMoldingAccionesRoles.sharedActions.validation],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Imprimir Etiquetas',
        url: '/packing-box-stage',
        roles: [...injectionMoldingAccionesRoles.sharedActions.packingBox],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Agregar Datos QC',
        url: '/add-qc-data',
        roles: [...injectionMoldingAccionesRoles.sharedActions.addQcData],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/injection-molding',
        // roles: [
        //   ...injectionMoldingAccionesRoles.sideNavActions
        //     .reportsPbiInjectionMolding,
        // ],
      },
      options: PreConfigButton3,
    },
  ],
};
